<template>
  <div class="stepper-container">
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="step-item"
      :class="{
        active: modelValue >= index,
        completed: modelValue > index,
        disabled: !canAccess(index),
      }"
      @click="handleStepClick(index)"
    >
      <div
        v-if="index < steps.length - 1"
        class="step-line"
        :class="{ filled: modelValue > index }"
      ></div>
      <div class="step-circle">
        <i v-if="modelValue > index" class="bi bi-check-lg"></i>
        <i v-else :class="step.icon"></i>
      </div>
      <span class="step-label">{{ step.label }}</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Number, required: true },
  stepsEnabled: { type: Array, default: () => [true, false] },
});
const emit = defineEmits(["update:modelValue"]);

const steps = [
  { label: "Datos personales", icon: "bi bi-person-vcard" },
  { label: "Datos de combate", icon: "bi bi-shield-fill" },
];

function canAccess(index) {
  return props.stepsEnabled?.[index] || index <= props.modelValue;
}
function handleStepClick(index) {
  if (canAccess(index)) emit("update:modelValue", index);
}
</script>

<style scoped>
.stepper-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #fff;
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  position: relative;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  cursor: pointer;
  transition: opacity 0.2s;
}
.step-item.disabled {
  cursor: not-allowed;
  opacity: 0.38;
}
.step-line {
  position: absolute;
  top: 18px;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  z-index: 0;
  transition: background 0.3s;
}
.step-line.filled {
  background: #007bff;
}
.step-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #e0e0e0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #aaa;
  z-index: 1;
  transition: all 0.25s;
}
.step-item.active .step-circle,
.step-item.completed .step-circle {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.15);
}
.step-label {
  margin-top: 8px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #aaa;
  text-align: center;
  transition: color 0.2s;
}
.step-item.active .step-label,
.step-item.completed .step-label {
  color: #007bff;
}

@media (max-width: 480px) {
  .step-label {
    display: none;
  }
  .step-circle {
    width: 32px;
    height: 32px;
    font-size: 0.95rem;
  }
  .step-line {
    top: 15px;
  }
}
</style>
